import { media, selectTheme, styled, Flex } from '@creditas-ui/react';

export const Footer = styled.nav`
  border-top: 1px solid ${selectTheme('colors.neutral.10')};
`;

export const FooterContainer = styled(Flex)`
  max-width: 280px;
  padding: 25px 20px 29px;
  ${media.up('3xl')} {
    max-width: 100%;
    padding: 22px 70px;
  }
`;

export const LogoContainer = styled.div`
  width: 30px;
  margin-right: 8px;
  ${media.up('3xl')} {
    width: 42px;
  }
`;
